module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-toolbar"
  }, [_vm._t("default"), _vm._v(" "), (_vm.showBack || _vm.showAutoback) ? [_c('div', {
    staticClass: "rt-divider"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleBackClick
    }
  }, [_vm._v("返回")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59167834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/toolbar/src/main.vue
// module id = 1508
// module chunks = 91